import { render, staticRenderFns } from "./ViewMyOrder.vue?vue&type=template&id=35241e38&scoped=true&"
import script from "./ViewMyOrder.vue?vue&type=script&lang=js&"
export * from "./ViewMyOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewMyOrder.vue?vue&type=style&index=0&id=35241e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35241e38",
  null
  
)

export default component.exports